export enum WidgetType {
  LightComparerWidget = 'LightComparerWidget',
  BaseInstallmentPicker = 'BaseInstallmentPicker',
  MeetingPlannerWidget = 'MeetingPlannerWidget',
  NaviboxBanner = 'NaviboxBanner',
  HalfPageBanner = 'HalfPageBanner',
  WideboardBanner = 'WideboardBanner',
  TextUrls = 'TextUrls',
  AffiliateLinks = 'AffiliateLinks',
  CreditWorthinessOffersWidget = 'CreditWorthinessOffersWidget',
  mbwWidget = 'mbwWidget',
  RefinanceWidget = 'RefinanceWidget',
  WidgetViewInfo = 'WidgetViewInfo',
  SimulationFormMortgage = 'SimulationFormMortgage',
  MortgageComparerFormWidget = 'MortgageComparerFormWidget',
}
